var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23334 15.2917L8.81667 17.2917C9.15 17.625 9.9 17.7917 10.4 17.7917H13.5667C14.5667 17.7917 15.65 17.0417 15.9 16.0417L17.9 9.95835C18.3167 8.79168 17.5667 7.79168 16.3167 7.79168H12.9833C12.4833 7.79168 12.0667 7.37501 12.15 6.79168L12.5667 4.12501C12.7333 3.37501 12.2333 2.54168 11.4833 2.29168C10.8167 2.04168 9.98334 2.37501 9.65 2.87501L6.23334 7.95835",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98334 15.2916V7.12496C1.98334 5.95829 2.48334 5.54163 3.65 5.54163H4.48334C5.65 5.54163 6.15 5.95829 6.15 7.12496V15.2916C6.15 16.4583 5.65 16.875 4.48334 16.875H3.65C2.48334 16.875 1.98334 16.4583 1.98334 15.2916Z",
    stroke: "#6E7E95",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.30cb4ace7f0c55f26abffaf131d30a0a.svg";
export { ForwardRef as ReactComponent };